export default "__VITE_ASSET__B1kjGUL3__"